import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light'
    },
    defaults: {
        // gives the v-data-table "per page" dropdown menu a class, so App.vue can make its items compact
        VDataTableFooter: {
            VSelect: {
                menuProps: { contentClass: 'app-data-table-per-page-menu' }
            }
        }
    }
});